import DatabaseModel from './DatabaseModel.js';
import { unwrapDto } from './responseUtils.js';

var Empleado = Object.create(DatabaseModel);

Empleado.model = 'empleado';
Empleado.modelFront = 'empleados';

// [#864] GET /movilidad/empleado/{id}/perfil-crm
// → { perfilCrm, opciones: [{ valor, permitida, motivo }], historial: [{ anterior, nuevo, autor, fecha, origen, usernameAnterior }] }
// Las opciones las decide la API con la misma regla con la que acepta o rechaza el guardado: la
// pantalla no calcula permisos por su cuenta. Un valor ausente es «Sin acceso».
Empleado.perfilCrm = function(id) {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + encodeURIComponent(id) + '/perfil-crm',
        method: 'GET'
    }, false).then(unwrapDto);
};

// [#864] GET /movilidad/empleado/perfil-crm/opciones → [{ valor, permitida, motivo }]
// Las de una ficha nueva, que no tiene perfil de antes.
Empleado.opcionesPerfilCrm = function() {
    const self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/perfil-crm/opciones',
        method: 'GET'
    }, false).then(function(res) {
        return unwrapDto(res) || [];
    });
};

export default Empleado;
